module.exports = __webpack_public_path__ + "img/fcb-logo-ko.c9b23261.png";